import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, Cookie } from '@phosphor-icons/react';
import { LEGAL_VERSION } from '../legal/content';
import { isNativeApp } from '../lib/native';

const ACK_KEY = `fz_legal_visitor_ack_${LEGAL_VERSION}`;

const VisitorDisclaimerBanner = () => {
  const [shown, setShown] = useState(false);
  // In the app the full notice takes a quarter of the screen; start collapsed.
  const [expanded, setExpanded] = useState(() => !isNativeApp());

  useEffect(() => {
    if (!localStorage.getItem(ACK_KEY)) setShown(true);
  }, []);

  const acknowledge = () => {
    localStorage.setItem(ACK_KEY, new Date().toISOString());
    setShown(false);
    window.dispatchEvent(new Event('fz-disclaimer-ack'));
  };

  if (!shown) return null;

  return (
    <div
      className="fixed bottom-3 left-3 right-3 sm:bottom-4 sm:left-1/2 sm:right-auto sm:-translate-x-1/2 sm:w-[640px] z-50 bg-black/85 backdrop-blur-xl border border-white/15 rounded-xl shadow-2xl p-4 sm:p-5"
      style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="visitor-disclaimer-banner"
      role="region"
      aria-label="Legal notice"
    >
      <div className="flex items-start gap-3">
        <Cookie aria-hidden="true" size={22} weight="fill" className="text-[#facc15] flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0 text-xs sm:text-[13px] text-white/85 leading-relaxed font-light">
          <p className={expanded ? 'mb-2' : ''}>
            <strong className="text-white">Fanzingy is a marketplace, not a fund.</strong>{' '}
            {expanded && (
              <>We connect film producers with fans, investors and the wider fraternity. Money flows through an RBI-registered Partner NBFC — not Fanzingy. </>
            )}
            <span className="text-white/75">Film investments are subject to risk.</span>
            {!expanded && (
              <>
                {' '}
                <button
                  type="button"
                  className="text-[#c084fc] underline underline-offset-2"
                  aria-expanded={expanded}
                  onClick={() => setExpanded(true)}
                  data-testid="visitor-banner-more"
                >
                  More
                </button>
              </>
            )}
          </p>
          {expanded && (
            <p className="text-white/70">
              By browsing this site you accept our use of cookies and confirm that you have read our{' '}
              <Link to="/legal/terms" className="text-[#c084fc] underline underline-offset-2">Terms</Link>,{' '}
              <Link to="/legal/privacy" className="text-[#c084fc] underline underline-offset-2">Privacy</Link>, and{' '}
              <Link to="/legal/risk" className="text-[#c084fc] underline underline-offset-2">Risk Disclosure</Link>.
            </p>
          )}
        </div>
        <button
          data-testid="visitor-banner-ack"
          onClick={acknowledge}
          className="bg-white text-black font-bold text-xs px-3 py-2 rounded-full flex-shrink-0 hover:scale-105 transition-transform whitespace-nowrap"
        >
          Got it
        </button>
        <button
          aria-label="Dismiss notice"
          onClick={acknowledge}
          className="text-white/70 hover:text-white flex-shrink-0 native-hide"
          data-testid="visitor-banner-x"
        >
          <X aria-hidden="true" size={16} weight="bold" />
        </button>
      </div>
    </div>
  );
};

export default VisitorDisclaimerBanner;
